<p-dialog #dialog appendTo="body" header="Switch -> Jack Lookup" [(visible)]="visible" [modal]="true"
		  [resizable]="true" (onHide)="onHide()" styleClass="switch-jack-lookup-dialog" (onShow)="onShow()"
		  [style]="{'width': '1200px', 'height': '800px', 'min-width': '625px', 'min-height': '670px'}">

	<switch-to-jack-lookup-editor [deviceGuid]="deviceGuid" [ifTableHeightVh]="0" [ifTableHeightPx]="ifTableHeightPxProp"
								  [ifTableMinHeight]="150" [visible]="visible">
	</switch-to-jack-lookup-editor>

	<p-footer>
		<button type="button" pButton icon="fa fa-times" [disabled]="false"
				(click)="onCloseClicked()" label="Close"></button>
	</p-footer>

</p-dialog>
